import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons';


function Pagination(props) {
    const { total, pageLength, currentPage, setCurrentPage } = props
    const totalPages = Math.ceil(total / pageLength) || 1
    const active = currentPage > totalPages ? setCurrentPage(totalPages) : currentPage
    let maxPage, minPage, ellipses;
    let pageRange = [];
    if(active <= 3) {
        maxPage = totalPages <= 5 ? totalPages : 5
        minPage = 1
        ellipses = totalPages > 5 ? { after: "......" } : {}
    } else if(active >= totalPages - 2) {
        maxPage = totalPages
        minPage = totalPages - 4
        ellipses = { before: "......" }
    } else {
        maxPage = active + 2
        minPage = active - 2
        ellipses = { before: "...", after: "..." }
    }
    for (let i = minPage; i <= maxPage; i++) pageRange.push(i)

    return (  
        <div className='d-flex'>
            <button className="paginate-button rounded-left" data-testid="paginate-left" onClick={() => setCurrentPage(active - 1) } disabled={ active === 1 }>
                <FontAwesomeIcon icon={ faCaretLeft } />
            </button>
            {/* {
                "before" in ellipses && (
                    <span>{ ellipses.before }</span>
                )
            } */}
            {
                pageRange.map((page, idx) => (
                    <div 
                        data-testid={ `pagination-button-${idx}` }
                        key={ idx }
                        onClick={() => setCurrentPage(page)}
                        className={ `border border-right-0 page-no ${ page === active && "active" }` }
                    >
                        { page }
                    </div>
                ))
            }
            {/* {
                "after" in ellipses && (
                    <span>{ ellipses.after }</span>
                )
            } */}
            <button className="paginate-button rounded-right" data-testid="paginate-right" onClick={() => setCurrentPage(active + 1)} disabled={ active === totalPages }>
                <FontAwesomeIcon icon={ faCaretRight } />
            </button>
        </div>
    )
}

export default Pagination
